export default function removeBr(stringToFormat: string) {
  return stringToFormat ? stringToFormat.replace(/<br\/?>/gi, '') : '';
}
